export const COMPOSITE_TEMPLATE_SELECTION_PAGE = '@PAGE/Creator/Setting/composite_template_selection';
export const COMPOSITE_TEMPLATE_SELECTION_TAB = '@TAB/Creator/Setting/composite_template_selection';
